//Manage carousel cards
function pelletsManager() {
	const pellets = [...document.querySelectorAll(".color-pellet")]
	
	const managePellet = (e, pellet) => {
		const productId = e.target.dataset.productid
		const variantImage = e.target.dataset.image
		const variantUrl = e.target.dataset.url
		const images = [...document.querySelectorAll(`.image-${productId}`)]
		const links = [...document.querySelectorAll(`.link-${productId}`)]
		const options = [...document.querySelectorAll(`.options-${productId}`)]

		images.forEach(slide => slide.src = variantImage)
		links.forEach(link => link.href = variantUrl)
		options.forEach(option => {
			const slidePellets = [...option.querySelectorAll('.color-pellet')]
				slidePellets.forEach(slidePellet => slidePellet.classList.remove('selected'))

				pellet.classList.add('selected')
		})
	}

	pellets.forEach(pellet => {
		const color = pellet.dataset.color
		const manageCurrentPellet = e => managePellet(e, pellet)
		pellet.style.backgroundColor = `${color}`
		pellet.addEventListener('click', manageCurrentPellet)
	})
}

onDomChange(function() {
	setTimeout(pelletsManager)
});


